module.exports = __webpack_public_path__ + "media/AD_Video_full.87260fca.mp4";